import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { LocalStorageService } from "src/app/utils/localstorage.service";

@Injectable({ providedIn: "root" })
export class RoleGuard {

  constructor(private localStorage: LocalStorageService) { }

  /**
   * Checks if user has a certain role in localStorage.
   */
  canActivate(route: ActivatedRouteSnapshot) {
    return (
        route.data.allowedRoles.includes(
            this.localStorage.get("userPermissions")?.role));
  }
}
